import styled, { css } from 'styled-components'

import { SelectionButton } from '../../shared-form-styles'

export const ButtonsWrapper = styled.div<{ $disabled: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;

  opacity: ${o => (o.$disabled ? 0.5 : 1)};
`

/**
 * A selected font reads as a bordered outline rather than the shared button's black fill — the
 * font name is already legible in its own typeface, so the fill would fight it for attention.
 * Only the new Embroidery Modal wants that treatment; elsewhere this falls back to the shared fill.
 */
export const FontSelectionButton = styled(SelectionButton)<{ outlineWhenSelected?: boolean }>`
  width: 100%;
  height: 40px;
  padding: 0 ${o => o.theme.spacing(2)};
  /* Long font names wrap to a second line, centered. */
  line-height: 1.2;
  text-align: center;

  ${o =>
    o.outlineWhenSelected
      ? css`
          background-color: white;
          color: ${o.theme.color.text.primary.on.background};
        `
      : css``}

  &:not([aria-disabled]):hover {
    background-color: ${o =>
      o.outlineWhenSelected || !o.isSelected
        ? o.theme.color.fill.subtle
        : o.theme.color.fill.strong};
  }
`
